module.exports = __webpack_public_path__ + "static/media/logo-white-2x.f80837f4.png";